module.exports = __webpack_public_path__ + "img/Digitaler_Sprechfunk.2e3a1aa8.svg";